import { MS_API_BACKEND_URL, ESTOQUE_BACKEND_URL } from "../settings";
import { api } from "./api";

class UserService {
  constructor() {
    this.url = MS_API_BACKEND_URL;
  }

  async getUser() {
    const url = `${this.url}/api/auth-internal/v2/user/me`;
    return await api.get(url);
  }

  async getUsers(params) {
    const url = `${this.url}/api/auth-internal/v2/user`;
    return await api.get(url, { params });
  }
}

const userService = new UserService();
export default userService;
